import React, { ReactNode } from 'react';
import styles from './ExpertSection.module.css';
import { FaQuoteRight, FaTerminal } from 'react-icons/fa';
import { isSmallScreen } from '../../../utils/screen';

interface ExpertSectionProps {
    title: ReactNode;
    description: ReactNode;
    quotes: ReactNode[];
    author: {
        name: string;
        role: ReactNode;
        image: string;
    };
}

const ExpertSection: React.FC<ExpertSectionProps> = ({ title, description, quotes, author }) => {
    return (
        <section className={styles.expert}>
            <div className={styles.container}>
                <div className={styles.expertContent}>
                    <div className={styles.titleContainer}>
                        <FaTerminal size={isSmallScreen() ? 44 : 54} className={styles.terminalIcon} />
                        <div className={styles.titleWrapper}>
                            <h2 className={styles.expertTitle}>
                                {title}
                            </h2>
                            <p className={styles.expertDescription}>
                                {description}
                            </p>
                        </div>
                    </div>
                    <div className={styles.expertQuote}>
                        <FaQuoteRight size={36} className={styles.quoteIcon} />
                        <div className={styles.quoteContent}>
                            {quotes.map((quote, index) => (
                                <p key={index} className={styles.quote}>{quote}</p>
                            ))}
                        </div>
                        <div className={styles.expertProfile}>
                            <img src={author.image} alt={author.name} className={styles.expertImage} />
                            <div className={styles.expertDetails}>
                                <h3 className={styles.expertName}>{author.name}</h3>
                                <p className={styles.expertRole}>{author.role}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ExpertSection; 